import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr2001',
    ecrans: ['00-2'],
    params: ['id', '?cclcleint']
});
